<div class="p-2">
    <!-- Title -->
    <div class="row pb-2">
      <div class="col-6 h5 text-muted p-0">Push Notification Campaign</div>
      <div class="col-6 p-0">
        <span class="float-end">
          <button type="button" class="btn btn-outline-secondary btn-sm" title="Create Push Notification Campaign" (click)="createPushNotificationCampaign()">
            Create Push Notification Campaign
          </button>
        </span>
      </div>
    </div>
  
    <div class="row bg-light p-2">
      <div class="col-12">
        
        <div class="row pt-2 pb-2 bg-white">
            <div class="col-12">

                <!-- Push Notification Campaigns -->
                <div class="row mt-4 pt-4 mb-4 pb-4 text-center" *ngIf="pushNotificationCampaignsLoading === true">
                    <div class="col-12">
                    <div class="spinner-border text-info  mt-4" role="status"></div>
                    </div>
                </div>

                <div class="row mt-2 pt-2 pb-4">
                    <div class="col-12">
                    <div class="row text-center mt-4 mb-4" *ngIf="pushNotificationCampaignsLoading == false && pushNotificationCampaigns.length == 0">
                        <i-bs class="text-black-50 mt-4 pt-4" name="chatSquareDots" width="30" height="30"></i-bs>
                        <div class="col-12 mb-4 pb-4 text-black-50">Push notification campaigns not found</div>
                    </div>

                    <div class="row" *ngIf="pushNotificationCampaignsCount > 0">
                        <div class="col-12">
                            <!-- Pagination Top -->
                            <pagination-controls class="float-end" style="font-size:12px" maxSize="4" autoHide="true" previousLabel=""
                            nextLabel="" (pageChange)="onPushNotificationCampaignsPageChange($event)"></pagination-controls>
                        </div>
                    </div>

                    <div class="row push-notification-campaign-list-outer" *ngIf="pushNotificationCampaignsLoading === false && pushNotificationCampaigns.length > 0">
                        <div class="col-12">
                            <!-- Header -->
                            <div class="row header-row border-bottom m-1">
                                <div class="col-3 title text-muted">Campaign Name</div>
                                <div class="col-2 title text-muted">Target Users</div>
                                <div class="col-2 title text-muted">Created Date</div>
                                <div class="col-2 title text-muted">Schedule Date</div>
                                <div class="col-2 title text-muted">Campaign Status</div>
                                <div class="col-1 title text-muted">Delivered</div>
                            </div> 

                            <!-- Data -->
                            <div class="row data-row border-bottom border-light m-1" *ngFor="let pushNotificationCampaign of pushNotificationCampaigns | paginate: { itemsPerPage: 10, currentPage: pushNotificationCampaignsPage, totalItems: pushNotificationCampaignsCount }; let i = index;">
                                <div class="col-3 value text-muted cursor-pointer" [ngbPopover]="pushNotificationCampaignDetailsPop" triggers="manual" #p1="ngbPopover" (mouseleave)="p1.close()" (click)="togglePushNotificationCampaignDetailsPopover(p1, pushNotificationCampaign)">
                                    <u>{{ pushNotificationCampaign.campaign_name }}</u>
                                    <span *ngIf="pushNotificationCampaign?.campaign_status == 0">
                                        &nbsp;&nbsp;<i-bs class="text-secondary cursor-pointer" name="pencilSquare" title="Edit Push Notification Campaign" (click)="onEditPushNotificationCampaign(pushNotificationCampaign)"></i-bs>
                                    </span>
                                </div>
                                <div class="col-2 value text-muted">
                                    {{ pushNotificationCampaign.campaign_topic_desc }}
                                </div>
                                <div class="col-2 value text-muted">
                                    {{ pushNotificationCampaign.create_date | date : 'MMM d, y' : 'UTC' }}
                                </div>
                                <div class="col-2 value text-muted">
                                    {{ pushNotificationCampaign.schedule_date | date : 'MMM d, y' : 'UTC' }}
                                </div>
                                <div class="col-2 value"> 
                                    <span class="text-warning" *ngIf="pushNotificationCampaign?.campaign_status == 0">Scheduled</span>
                                    <span class="text-success" *ngIf="pushNotificationCampaign?.campaign_status == 1">Completed</span>
                                    <span class="text-danger" *ngIf="pushNotificationCampaign?.campaign_status == 2">Cancelled</span>
                                </div>
                                <div class="col-1 value"> 
                                    <span *ngIf="pushNotificationCampaign?.campaign_status == 1">{{ pushNotificationCampaign?.success_count }}/{{ pushNotificationCampaign.no_of_users }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Pagination Bottom -->
                    <div class="row mt-2">
                        <div class="col-12">
                        <pagination-controls class="float-end" style="font-size:12px" maxSize="4" autoHide="true" previousLabel=""
                            nextLabel="" (pageChange)="onPushNotificationCampaignsPageChange($event)" *ngIf="pushNotificationCampaignsCount > 0"></pagination-controls>
                        </div>
                    </div>
                    </div>
                </div>
        
            </div>
        </div>
        
      </div>
    </div>
  </div>

  <!-- Push Notification Campaign Details Popover-->
  <ng-template #pushNotificationCampaignDetailsPop>
    <div class="container popover-outer p-0">
        <div class="row">
            <div class="col-12">
                <img class="img" [src]="pushNotificationCampaignDetailsPopData.image" *ngIf="pushNotificationCampaignDetailsPopData.image">
                <div class="title">{{ pushNotificationCampaignDetailsPopData.title }}</div>
                <div class="text">{{ pushNotificationCampaignDetailsPopData.message }}</div>
            </div>
        </div>
    </div>
  </ng-template>
